export default __webpack_public_path__ + "static/media/BellBoy-demo.fe32a5ef.mp4";